/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type InvoiceFilterButton_project$ref: FragmentReference;
declare export opaque type InvoiceFilterButton_project$fragmentType: InvoiceFilterButton_project$ref;
export type InvoiceFilterButton_project = {|
  +id: string,
  +$refType: InvoiceFilterButton_project$ref,
|};
export type InvoiceFilterButton_project$data = InvoiceFilterButton_project;
export type InvoiceFilterButton_project$key = {
  +$data?: InvoiceFilterButton_project$data,
  +$fragmentRefs: InvoiceFilterButton_project$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InvoiceFilterButton_project",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "ProjectType"
};
// prettier-ignore
(node/*: any*/).hash = '039e698c963209de9dff18bd632f751c';

module.exports = node;
